import { OspToast } from "@ospweb/sdk-ui";
import { DIAGNOSIS_UNLOCK_ACTIONS } from "./diagnosisUnlockChrome";

export const DIAGNOSIS_UNLOCK_FETCH_ERROR_TOAST =
  "Couldn't load this report. Please try again.";

export function showDiagnosisUnlockFetchErrorToast(): void {
  OspToast.error({ content: DIAGNOSIS_UNLOCK_FETCH_ERROR_TOAST });
}

export function getDiagnosisUnlockFetchDismissAction(): string {
  return DIAGNOSIS_UNLOCK_ACTIONS.reportClose;
}
